import React from 'react'
import { Link } from 'react-router-dom'
import './Bottomnav.css'

function Bottom({size}) {
  return (
    <div>
        <nav className="mobile-nav">
        <Link to={'/'} className="links">
            <a href="#" className='bloc-icon'>
                <img src="https://i.postimg.cc/7LCXc4wS/home.png" alt=""/> Home   
            </a>
        </Link>
        <Link to={'/'} className="links">
            <a href="#" className="bloc-icon" >
                <img src="https://i.postimg.cc/CdyVbGGw/products.png" alt=""/>
                Products
            </a>
        </Link >
        <Link to={'/'} className="links">
            <a href="#" className="bloc-icon" >
                <img src="https://i.postimg.cc/SRRKgfY8/featured.png" alt=""/>
                Featured
    
            </a>
        </Link>
        <Link to={'/cart'} className="links">
            <a href="#" className="bloc-icon">
                <img src="https://i.postimg.cc/jjfd9jjg/cart.png" alt=""/>
                Cart<span style={{fontSize:"14px" , color:"orange"}}>{size}</span>
            </a>

        </Link>
    </nav>
    </div>
  )
}

export default Bottom
